export default import.meta.ROLLDOWN_FILE_URL_Otw96mOua4$0Kwg7klCs0Q